import React, { FC } from 'react';

import styled from 'styled-components';

import CloseButton from 'components/close-button';
import Modal from 'components/modal';
import { SetLoyaltyCardRewardsTierMutationHookResult } from 'generated/rbi-graphql';
import { primitive } from 'styles/constants/primitives';

import { Background } from '../styled';

import RewardCategories from '.';

const ModalCloseButton = styled(CloseButton)`
  left: calc(1.25rem + env(safe-area-inset-left));
  position: fixed;
  top: calc(1rem + env(safe-area-inset-top));
  z-index: ${Styles.zIndex.below};
  color: ${p => p.theme.token('text-button-primary')};
  background: transparent;
`;

const RewardCategoriesContainer = styled.div`
  padding: ${primitive.$spacing11} ${primitive.$spacing5} ${primitive.$spacing10};
`;

const AllModalContent = styled.div`
  background-color: ${p => p.theme.token('background-pattern')};
  width: 100%;
  height: 100%;
`;

interface IRewardCategoriesModalProps {
  onDismiss: () => void;
  radioButtonName: string;
  setSelectedRewardsTier: SetLoyaltyCardRewardsTierMutationHookResult[0];
}

export const RewardCategoriesModal: FC<IRewardCategoriesModalProps> = ({
  onDismiss,
  radioButtonName,
  setSelectedRewardsTier,
}) => (
  <Modal
    closeButton={ModalCloseButton}
    onDismiss={onDismiss}
    mParticleEventData={{ modalAppearanceEventMessage: 'Reward Categories' }}
  >
    <AllModalContent>
      <Background>
        <RewardCategoriesContainer>
          <RewardCategories
            radioButtonName={radioButtonName}
            setSelectedRewardsTier={selectedTier => {
              onDismiss();
              return setSelectedRewardsTier(selectedTier);
            }}
          />
        </RewardCategoriesContainer>
      </Background>
    </AllModalContent>
  </Modal>
);
